import { SearchFilterContext } from 'Areas/Broadband/React/js/components/filters/SearchFilterContext';
import { useCallback, useContext, useState } from 'react';

import { business, personal } from './SupplierContext';
import SuppliersList from './SuppliersList';
import { SupplierStatus } from './SupplierStatus';

export interface SuppliersSectionProps {
    supplierStatuses: SupplierStatus[];
    statusChanger: (supplierStatus: SupplierStatus[]) => void;
    isBusiness: boolean;
    isAllSelected: boolean;
    OnSelectChange: (e: React.ChangeEvent<HTMLInputElement>, isBusiness: boolean) => void;
    isVerticallyAligned: boolean;
}

export default function SuppliersSection(props: SuppliersSectionProps) {
    const searchContext = useContext(SearchFilterContext);

    const OnSelectChange = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            props.OnSelectChange(e, props.isBusiness);
        },
        [props]
    );

    const buildSupplierList = useCallback(() => {
        return (
            <div className="modal-results-broadband-grid bor-t-1 pad-y-5">
                <SuppliersList
                    isVerticallyAligned={props.isVerticallyAligned}
                    className="supplier-list block-grid-xs-2 block-grid-md-3 block-grid-condensed pad-t-3"
                    supplierStatuses={props.supplierStatuses.filter(s =>
                        props.isBusiness ? s.supplier.isBusiness : s.supplier.isPersonal
                    )}
                    statusChanger={props.statusChanger}
                    disabled={false}
                    suffix={`-${props.isBusiness ? business : personal}`}
                />
            </div>
        );
    }, [props]);

    const [collapsed, setCollapsed] = useState<boolean>(false);

    const onCollapseToggle = useCallback(() => {
        setCollapsed(!collapsed);
    }, [collapsed]);

    const expandClass = useCallback((): string => {
        return `fa pad-l-5 ${collapsed ? 'fa-chevron-up' : 'fa-chevron-down'}`;
    }, [collapsed]);

    const allId = props.isBusiness ? 'selectAll-business-checkbox' : 'selectAll-personal-checkbox';
    return (
        <div>
            <div className="row pad-t-2 pad-b-3">
                <div className="col-xs-24">
                    <div className="checkbox-tick font-4 pad-t-8 pad-b-3">
                        <input type="checkbox" id={allId} checked={props.isAllSelected} onChange={OnSelectChange} />
                        <label className="font-300" htmlFor={allId}>
                            <span>
                                {props.isBusiness
                                    ? searchContext.data.resources.businessProviders
                                    : searchContext.data.resources.selectAll}
                            </span>
                        </label>
                        {props.isBusiness ? <span onClick={onCollapseToggle} className={expandClass()}></span> : null}
                    </div>
                </div>
            </div>
            {props.isBusiness ? collapsed && buildSupplierList() : buildSupplierList()}
        </div>
    );
}
